import React from 'react';
import { Box, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";

const _ep_BANNER_BANNER_FULL = ({ banners, eagerFirstBanner = false }) => {
    const navigate = useNavigate();

    if (!banners || !Array.isArray(banners) || banners.length === 0) return null;

    const handleBannerClick = (url) => {
        if (!url) return;
        if (url.startsWith("http://") || url.startsWith("https://")) {
            window.open(url, "_blank");
        } else {
            navigate(url);
        }
    };

    const getResponsiveDisplay = (viewType) => {
        if (!viewType) return "block";
        const vt = String(viewType).toLowerCase();
        const validBreakpoints = ["xs", "sm", "md", "lg", "xl"];
        if (validBreakpoints.includes(vt)) {
            return {
                xs: "none",
                sm: "none",
                md: "none",
                [vt]: "block"
            };
        }
        return "block";
    };

    return (
        <Box sx={{ my: { xs: 2.5, sm: 3 }, px: { xs: 2, sm: 2.5 } }}>
            {banners.map((item, index) => {
                const isClickable = Boolean(item?.Url);
                const bannerKey = item?.Id ? `banner-full-${item.Id}` : `banner-full-${index}`;

                return (
                    <Card
                        key={bannerKey}
                        onClick={() => handleBannerClick(item?.Url)}
                        sx={{
                            display: getResponsiveDisplay(item?.ViewType),
                            borderRadius: "20px",
                            overflow: "hidden",
                            cursor: isClickable ? "pointer" : "default",
                            boxShadow: "0 10px 28px -6px rgba(0, 0, 0, 0.08), 0 4px 12px -2px rgba(0, 0, 0, 0.04)",
                            border: "1px solid",
                            borderColor: "divider",
                            backgroundColor: "background.paper",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": isClickable
                                ? {
                                    transform: "translateY(-4px)",
                                    boxShadow: "0 18px 36px -8px rgba(0, 0, 0, 0.14)",
                                    borderColor: "rgba(231, 51, 62, 0.25)"
                                }
                                : {},
                            "&:active": isClickable
                                ? {
                                    transform: "scale(0.985)"
                                }
                                : {}
                        }}
                    >
                        <Box
                            component="img"
                            src={item?.multimedia?.Url}
                            alt={item?.Name || "بنر جیم‌پین"}
                            loading={eagerFirstBanner && index === 0 ? "eager" : "lazy"}
                            fetchPriority={eagerFirstBanner && index === 0 ? "high" : undefined}
                            decoding="async"
                            sx={{
                                display: "block",
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                transition: "transform 0.4s ease",
                                "&:hover": isClickable
                                    ? {
                                        transform: "scale(1.02)"
                                    }
                                    : {}
                            }}
                        />
                    </Card>
                );
            })}
        </Box>
    );
};

export default React.memo(_ep_BANNER_BANNER_FULL);

